/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

export type MicropaymentActionType =
  (typeof MicropaymentActionType)[keyof typeof MicropaymentActionType];

export const MicropaymentActionType = {
  accept: "accept",
  reject: "reject",
} as const;
